import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';

var LogModal = function (_super) {
  __extends(LogModal, _super);

  function LogModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.loading = false;
    _this.dataList = [];
    _this.total = 0;
    _this.searchData = _this.initSearchData();
    _this.columns = [{
      title: _this.t('操作人'),
      dataIndex: 'operator',
      filterEmpty: true
    }, {
      title: _this.t('操作类型'),
      dataIndex: 'log_type_text',
      filterEmpty: true
    }, {
      title: _this.t('备注'),
      dataIndex: 'log_content',
      width: 400,
      scopedSlots: {
        customRender: 'log_content'
      },
      filterEmpty: true
    }, {
      title: _this.t('时间'),
      dataIndex: 'create_time',
      filterEmpty: true
    }];
    return _this;
  }

  LogModal.prototype.handleVisibleChange = function (val) {
    if (val) {
      this.searchData = this.initSearchData();
      this.queryLogList();
    } else {
      this.dataList = [];
      this.total = 0;
    }
  };

  LogModal.prototype.initSearchData = function () {
    var _a;

    return {
      id: ((_a = this.record) === null || _a === void 0 ? void 0 : _a.id) || '',
      page_index: 1,
      page_size: 20
    };
  };

  LogModal.prototype.queryLogList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4, this.$api.product.queryAdditionalServicesConfigLog(this.searchData)];

          case 1:
            data = _a.sent().data;
            this.dataList = (data === null || data === void 0 ? void 0 : data.list) || [];
            this.total = (data === null || data === void 0 ? void 0 : data.total) || 0;
            return [3, 3];

          case 2:
            error_1 = _a.sent();
            this.dataList = [];
            this.total = 0;
            return [3, 3];

          case 3:
            return [2];
        }
      });
    });
  };

  LogModal.prototype.handlePageChange = function (pageIndex, pageSize) {
    this.searchData.page_index = pageIndex;
    this.searchData.page_size = pageSize;
    this.queryLogList();
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], LogModal.prototype, "record", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], LogModal.prototype, "handleVisibleChange", null);

  __decorate([loading('loading')], LogModal.prototype, "queryLogList", null);

  LogModal = __decorate([Component], LogModal);
  return LogModal;
}(Vue);

export default LogModal;